import React from 'react';
import './login.scss'
import frontlineLogo from "../../assets/img/frontlineio-logo.svg";
import PlayStoreBadge from "../../assets/img/google-play-badge.png";
import Settings from "../../settings.json";
import AppStoreBadge from "../../assets/img/app-store-badge.png";
import {Button} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Utility from "../../Utility";
import {isIOS} from "react-device-detect";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {useStores} from "../../Hooks";


export default function MobileUserPage() {
    const {generalStore} = useStores();


    async function tryOpen() {

        if (!Utility.isMobile()) {
            window.location.href = `procedureio://frontline-ar?d=${Settings.frontlineArServer}`;
        } else {
            window.location.href = `procedureio://frontline`;
        }
    }

    function downloadStore() {

        if (Utility.isAndroid()) {
            window.location.href = Settings.playStoreLink;
        }
        if (isIOS) {
            window.location.href = Settings.appStoreLink;
        }
    }

    return (
        <div className='on-boarding-container'>
            <img src={frontlineLogo} alt='' className='logo'/>
            {/*<LanguageMenu onBoarding={true}/>*/}
            <div className='on-boarding-box-container waiting-workspace'>

                <div className='frontline-ar-title'>
                    {generalStore.translate('youDoNotHavePermissionToViewThisWorkspaceViaTheWeb')}<br/>
                    {generalStore.translate('pleaseDownloadTheRelevantFrontlineIoApplication')}
                </div>
                <ConditionalComponent if={!Utility.isMobile()}>
                    <div className='waiting-workspace-text'>
                        <Button
                            color='primary'
                            variant='contained'
                            className='install-button'
                            onClick={Utility.downloadApp}
                        >
                            {generalStore.translate('installOnThisDevice')} <SaveAltIcon/>
                        </Button>
                    </div>
                    <div className='waiting-workspace-text'>
                        {generalStore.translate('orDownloadToMobileDevice')}
                        <div className='store-badges-container'>
                            <img
                                src={PlayStoreBadge}
                                alt='play-store-badge'
                                className='store-badge'
                                onClick={() => window.location.href = Settings.playStoreLink}
                            />
                            <img
                                src={AppStoreBadge}
                                alt='play-store-badge'
                                className='store-badge'
                                onClick={() => window.location.href = Settings.appStoreLink}
                            />
                        </div>
                    </div>
                </ConditionalComponent>
                <ConditionalComponent if={Utility.isMobile()}>

                    <div className='waiting-workspace-text'>
                        <Button color='primary' variant='contained' className='install-button'
                                onClick={downloadStore}>
                            {generalStore.translate('installOnThisDevice')} <SaveAltIcon/>
                        </Button>
                    </div>
                </ConditionalComponent>
                <div className='waiting-workspace-text try-open-container'>
                    {generalStore.translate('alreadyHaveTheApp')}&nbsp;
                    <Button
                        className='try-open-link'
                        onClick={tryOpen}
                        disableRipple
                    >
                        {generalStore.translate('clickHereToOpen')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
